import React from 'react'

const UploadedImage = ({
  published,
  fileUrl,
  id,
  dataTestId,
  imageClassName,
}: {
  published: boolean
  fileUrl: string
  id: string
  dataTestId?: string
  imageClassName?: string
}) => {
  return (
    <div className='image-container-wrapper' data-testid={dataTestId}>
      <label className='upload-img-cont' htmlFor={id}>
        {published ? null : <i className='fa fa-plus-circle remove-img-icon' />}
        {fileUrl ? (
          <img
            src={fileUrl}
            alt='project-img'
            className={`project-image${imageClassName ? ` ${imageClassName}` : ''}`}
          />
        ) : null}
      </label>
    </div>
  )
}

export { UploadedImage }
